import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=18730a2c&"
import script from "./ImageCard.vue?vue&type=script&lang=js&"
export * from "./ImageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports